
import React from "react";

// reactstrap components
import {
  CardText,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Table,
  Container,
  Row,
  Col
} from "reactstrap";
// core components
import AuthHeader from "../../../components/Headers/AuthHeader";

class Introduction extends React.Component {
  render() {
    return (
      <>
        <AuthHeader title="GIỚI THIỆU TRUNG TÂM LUYỆN THI CCL MAGIC" lead="" />
        <Container className="mt--8 pb-5">
          <Row className="justify-content-center">
            <Col lg="10">
            <Card>
              <CardBody>
                  <CardText className="mt-4">
                  CCL Magic tự hào là một trong những đơn vị tiên phong trong luyện thi CCL Magic cho người Việt, có cơ sở rộng khắp tại Melbourne CBD, Sydney, TP Hồ Chí Minh và Hà Nội.
                  </CardText>
                  <CardText className="mt-4">
                  Với hàng nghìn học viên trong những năm qua, CCL Magic đã và đang là địa chỉ tin cậy được nhiều bạn lựa chọn để ôn luyện Tiếng Anh giúp các bạn đi du học, di cư hay di trú thành công.
                  </CardText>
                  <CardText className="mt-4">
                  CCL Magic chúng tôi luôn tâm niệm rằng, học Tiếng Anh không chỉ là học một loại ngôn ngữ mới phục vụ cho việc lấy chứng chỉ, mà còn rèn luyện bản thân, khả năng tư duy giúp bạn phản xạ nhanh với môi trường thực tế dù gặp bất cứ rào cản khó khăn nào.
                  </CardText>
                  <CardText className="mt-4">
                  CCL Magic chúng tôi luôn tâm niệm rằng, học Tiếng Anh không chỉ là học một loại ngôn ngữ mới phục vụ cho việc lấy chứng chỉ, mà còn rèn luyện bản thân, khả năng tư duy giúp bạn phản xạ nhanh với môi trường thực tế dù gặp bất cứ rào cản khó khăn nào.
                  </CardText>
              </CardBody>
          </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default Introduction;
